import React from "react";
import "./Grocery.css";
import loblaw from "../../assets/loblaw.png";
import oldUI from "../../assets/oldUI.png";
import loblaws from "../../assets/loblaw.gif";

export default function Grocery() {
  return (
    <>
      <div className="grocery-section">
        <div className="grocery-about">
          <h4>Self-Checkout Concept Design </h4>
          <p className="grocery-about-status">
            Many stores now provide self-checkout lanes, where customers can
            complete their purchases using a touch-screen interface, a scanner,
            and weight-sensitive packing surfaces. While the basic interaction
            steps of beginning the checkout, scanning individual items, and
            making a payment are supported, many customers experience confusion,
            inefficiency, and hurdles when completing their transaction. There
            is much opportunity for an improved checkout experience for guests,
            using some fundamental principles of good UI and UX design.
          </p>
          <br />
        </div>
        <div className="grocery-demo">
          <img
            src={loblaw}
            alt="displaying old and new interface of speakhabla website"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      </div>

      <div className="grocery-section">
        <div className="grocery-about">
          <h4>User Research (Field Study & Observation)</h4>
          <p className="grocery-about-status">
            I observed some users while checking out groceries using the
            self-checkout system. I noticed they had a challenge understanding
            part of the user interface(e.g coupon logging) of the checkout
            machine.I want to help with including more appropriate icons,text
            labels and adequate instructions to help them check out their
            groceries seamlessly.
            <br /> Heuristic Violated: #3 user control and freedom.
          </p>
          <br />
        </div>
      </div>

      <div className="grocery-section">
        <div className="grocery-about">
          <h4> User Pain Points</h4>
          <p className="grocery-about-status">
            During the field study, I observed that the icons displayed checkout
            screens were inconsistent,misleading and did not really represent
            what they were intended to do. Error is not properly handled and
            there is no broad payment option accepting payment via coupon.
          </p>
          <br />
        </div>

        <div className="grocery-demo1">
          <img
            src={oldUI}
            alt="Sofia's Persona"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="grocery-section">
        <div className="grocery-about">
          <h4>Prototype</h4>
          <p className="grocery-about-status">
            All of these pain-points informed the choice and design solutions as
            seen here. I decided to take it a bit further by customizing it for
            Loblaws. The was built with Figma and you can find the interactive
            prototype.{" "}
            <a
              href="https://www.figma.com/proto/N38zdvUD3a3cKgRatSDjZW/Grocery-store-self-checkout?node-id=2%3A20&scaling=scale-down&page-id=0%3A1&starting-point-node-id=2%3A20&show-proto-sidebar=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </p>
          <br />
        </div>

        <div className="grocery-demo">
          <img
            src={loblaws}
            alt="loblaw selfcheckout interactive prototype"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>
    </>
  );
}
